export enum PaymentEnum {
  Congress = 'CONGRESS',
  Course = 'COURSE',
  Default = 'DEFAULT',
  Hotel = 'HOTEL',
  Membership = 'MEMBERSHIP',
  Subscription = 'SUBSCRIPTION',
  Webcast = 'WEBCAST',
}
